export const Config = {
  PlayerSpeed: 16 * 4, // pixels/sec
  PlayerFrameSpeed: 100, // ms
  GrandpaSpeed: 16, // pixels/sec
  GrandpaFrameSpeed: 100, // ms
};
